<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >生成分红数据</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="生成分红"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" label-width="100px">
        <el-form-item label="日期：" prop="price">
          <el-date-picker
            v-model="detail.day"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="价格：" prop="price">
          <el-input v-model="detail.price" :min="0"></el-input>
        </el-form-item>
        <el-form-item label="期数：" prop="stage">
          <el-input
            v-model="detail.stage"
            placeholder="XX期，如（二十四）,填写后会发送短信给用户"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'foundationCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {
        day: '',
        price: ''
      }
    };
  },
  components: {
    Editor,
    Upload
  },
  computed: {
    ...mapState('userdividend', ['coinTypeList', 'languageList', 'pagination'])
  },
  methods: {
    ...mapMutations('userdividend', ['setList']),
    ...mapActions('userdividend', ['create', 'getList']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      if (!this.detail.day || !this.detail.price) {
        this.$message({
          message: '数据不能为空',
          type: 'error'
        });
      } else {
        this.create(this.detail).then(res => {
          this.$message({
            message: '数据生成中！',
            type: 'success'
          });
          this.$emit('refresh', this.pagination);
          this.dialogVisible = false;
        });
      }
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
